'use strict';

module.exports = {
    submitArticleSearch: function () {
        $('body').on('submit', '.js-support-search-form', function (e) {
            e.preventDefault();
            var $this = $(this);

            if (!$('.js-support-search-query').val().trim().length) {
                return;
            }

            var data = $this.serialize();
            var url = $this.attr('action');

            $('.page').spinner().start();
            $.ajax({
                data: data,
                url: url,
                method: 'GET',
                success: function (data) {
                    $('.js-support-data-container').empty().html(data.template);
                    $.spinner().stop();
                }
            });
        });
    },
    clearArticleSearch: function () {
        $('body').on('click', '.js-clear-search', function () {
            var $this = $(this);
            var url = $this.data('url');

            $('.page').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (data) {
                    $('.js-support-data-container').empty().html(data.template);
                    $.spinner().stop();
                }
            })
        });
    }
};
